import { isEmpty } from 'lodash/fp';
import { TextKey } from '@mews-commander/enums';
import { LocalizedText, useDateTimeLocalizationInfo } from '@mews/framework';
import { ColumnAlignment } from '@mews/b2b-ui';
import { ContentCard } from '@mews-commander/ui';
import { WithAvailabilityBlockId } from '@mews-commander/types';
import { ResponsiveTable } from '@mews-commander/ui/legacy';
import AvailabilityBlockStateTag from '../../../../components/commander-ui/connected/AvailabilityBlockStateTag';
import { AvailabilityBlockLinkName } from '../AvailabilityBlockLinkName';
import { useAvailabilityBlock } from '../../../availabilityBlock/utils/useAvailabilityBlock';
import { getBlockReleaseStrategyView } from '../../../availabilityBlock/utils/getBlockReleaseStrategyView';

const AvailabilityBlockRelease = ({ availabilityBlockId }: WithAvailabilityBlockId) => {
    const block = useAvailabilityBlock(availabilityBlockId);
    const localizationInfo = useDateTimeLocalizationInfo();

    if (!block) return null;

    return getBlockReleaseStrategyView(block, localizationInfo).value;
};

export interface AvailabilityBlockCardProps {
    source: Array<string>;
}

const tableMapping = [
    {
        title: <LocalizedText textKey={TextKey.Name} />,
        valueKey: 'name',
        render: (id: string) => <AvailabilityBlockLinkName availabilityBlockId={id} />,
    },
    {
        title: <LocalizedText textKey={TextKey.AvailabilityBlockState} />,
        valueKey: 'state',
        columnAlignment: ColumnAlignment.Right,
        render: (id: string) => <AvailabilityBlockStateTag availabilityBlockId={id} />,
    },
    {
        title: <LocalizedText textKey={TextKey.Release} />,
        valueKey: 'release',
        columnAlignment: ColumnAlignment.Right,
        render: (id: string) => <AvailabilityBlockRelease availabilityBlockId={id} />,
    },
];

export const AvailabilityBlockCard = ({ source }: AvailabilityBlockCardProps) => {
    if (isEmpty(source)) return null;

    return (
        <ContentCard title={<LocalizedText textKey={TextKey.AvailabilityBlock} />}>
            <ResponsiveTable mapping={tableMapping} source={source} data-test-availability-block-table />
        </ContentCard>
    );
};
